:host {
  display: block;
}

h6 {
  font-family:'Lato';
  font-weight:'semi-bold';
  line-height:160%;
  font-size:21px;
  letter-spacing:0.15;
  text-decoration:none;
}